import { usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_POPUP_TYPE, PACKAGE_STATUS } from "@elixir/types";
import React, { PropsWithChildren } from "react";
import { Spinner, TreatmentIntroUi } from "ui";
import useGetQueueConfig from "../apis/tryst/get-queue-config";
import useGetPatientOverview from "../apis/tryst/use-get-patient-overview";
import PackagesAndTreatmentsPopupsAndDrawers from "../organisms/packages-and-treatments/packages-and-treatments-popups-and-drawers";
import CurrentTreatment from "../organisms/packages-and-treatments/packages-and-treatments-popups-and-drawers/current-treatment";
import { RendererParams } from "../react-app-env";
import { track } from "../utils/tracking";

const CurrentTreatmentScreen = (
  props: PropsWithChildren<Partial<RendererParams>>
) => {
  const setIncludeCompletedPackage = usePackageBookingStore(
    (state) => state.setIncludeCompletedPackage
  );
  React.useEffect(() => {
    setIncludeCompletedPackage && setIncludeCompletedPackage(true);
    track("current_treatment_screen");
    return () => {
      setIncludeCompletedPackage && setIncludeCompletedPackage(false);
    };
  }, [setIncludeCompletedPackage]);

  const patient_oid = props.routeParams?.patient_oid as string;
  const setSelectedPatient = usePackageBookingStore(
    (state) => state.setSelectedPatient
  );
  const setPackagePopupType = usePackageBookingStore(
    (state) => state.setPackagePopupType
  );
  const setShowClinicSelector = usePackageBookingStore(
    (state) => state.setShowClinicSelector
  );

  const { data: patientOverviewData, isLoading } = useGetPatientOverview({
    patientId: patient_oid,
  });

  React.useEffect(() => {
    if (patientOverviewData?.package && patientOverviewData?.patient) {
      setSelectedPatient(patientOverviewData.patient);
      return;
    }
    if (patientOverviewData?.patient) {
      setSelectedPatient(patientOverviewData.patient);
    }
  }, [
    patientOverviewData?.patient,
    patientOverviewData?.package,
    setSelectedPatient,
  ]);

  const { data: queueConfigData, isLoading: isQueueConfigLoading } =
    useGetQueueConfig();
  const queueConfigPackages = queueConfigData?.data?.packages || [];

  if (isLoading || isQueueConfigLoading) {
    return (
      <div className="dr-w-full dr-h-full dr-bg-darwin-touch-neutral-0 dr-flex dr-justify-center dr-items-center">
        <Spinner className="dr-text-darwin-touch-primary-primary" size={24} />
      </div>
    );
  }

  const handleCreatePackageClick = () => {
    setPackagePopupType(PACKAGE_POPUP_TYPE.CREATE_PACKAGE);
  };

  const handleStartPackageClick = () => {
    setShowClinicSelector(true);
    setPackagePopupType(PACKAGE_POPUP_TYPE.START_TREATMENT);
  };
  const showStartTreatmentButton =
    patientOverviewData?.package?.status === PACKAGE_STATUS.COMPLETED;

  return (
    <>
      {patientOverviewData?.package ? (
        <CurrentTreatment
          showRedeemPackage={false}
          showBookSlot={false}
          onStartClick={
            showStartTreatmentButton ? handleStartPackageClick : undefined
          }
        />
      ) : (
        <TreatmentIntroUi
          hasPackages={!!queueConfigPackages.length}
          onCreateClick={handleCreatePackageClick}
          onStartClick={handleStartPackageClick}
        />
      )}
      <PackagesAndTreatmentsPopupsAndDrawers />
    </>
  );
};

export default CurrentTreatmentScreen;
